import { GridAction } from '@eforall/dashboard';
import { Contact } from '@interfaces';

export function getActions() {

	const actions: GridAction<Contact>[] = [
	];

	return actions;
}